import React from 'react';
import { TIGHT_FIT_PARAM } from 'constants/System';
import { isEmpty } from 'services/Validation';

const ListRowImage = ({ width, data }) => {
    const { name, thumb } = data;
    if (width > TIGHT_FIT_PARAM) {
        if (isEmpty(thumb)) {
            return <React.Fragment>
                <div className="rounded-circle size-40 bg-blue text-center text-white mx-1 mx-md-3"
                    style={{ fontSize: 20 }}>
                    {name ? name.charAt(0).toUpperCase() : ''}
                </div>
            </React.Fragment>;
        } else {
            return <img className="rounded-circle size-40 mx-1 mx-md-3" alt={name} src={thumb} />;
        }
    } else {
        return null;
    }
};

export default ListRowImage;


// WEBPACK FOOTER //
// ./components/listRowImage/index.js